import { FeatureFlags } from "./flags.types";

// NOTE: do NOT deep nest
export const flags: FeatureFlags = {
  paymentOptions: ['pix_juno', 'credit_card_stripe', 'crypto_coinbase'],
  loginProviders: ['facebook', 'google']
}